export class SurgicalOrderAlreadyConcludedError extends Error {
  constructor() {
    super('Pedido cirúrgico já cancelado')
    this.name = 'SurgicalOrderAlreadyConcludedError'
  }
}
